<template>
  <aside class="adoc-sidebar" aria-label="Documentation navigation">
    <button type="button" class="adoc-sidebar__back" @click="$emit('close')">
      <v-icon icon="mdi-arrow-left" size="18" />
      <span>Back to API</span>
    </button>

    <p class="adoc-sidebar__label">Contents</p>

    <nav class="adoc-sidebar__nav">
      <template v-for="(item, index) in filteredNavigation" :key="`${item.kind}-${index}`">
        <p v-if="item.kind === 'section'" class="adoc-sidebar__section">
          {{ item.label }}
        </p>
        <button
          v-else
          type="button"
          class="adoc-sidebar__link"
          :class="{ 'adoc-sidebar__link--active': activeId === item.id }"
          @click="$emit('navigate', item.id)"
        >
          <v-icon :icon="iconFor(item.id)" size="16" class="adoc-sidebar__link-icon" />
          <span>{{ item.label }}</span>
        </button>
      </template>
    </nav>


  </aside>
</template>

<script setup>
import { computed } from 'vue'
import { getSectionIcon } from '@/utils/apiDocumentation'

defineOptions({ name: 'ApiDocsSidebar' })

const props = defineProps({
  navigation: { type: Array, default: () => [] },
  activeId: { type: String, default: '' },
  searchQuery: { type: String, default: '' },
})

defineEmits(['navigate', 'close'])

const filteredNavigation = computed(() => {
  const query = String(props.searchQuery ?? '').trim().toLowerCase()
  if (!query) return props.navigation

  const result = []
  let currentSection = null

  for (const item of props.navigation) {
    if (item.kind === 'section') {
      currentSection = item
      continue
    }
    if (item.label.toLowerCase().includes(query)) {
      if (
        currentSection &&
        !result.some((entry) => entry.kind === 'section' && entry.label === currentSection.label)
      ) {
        result.push(currentSection)
      }
      result.push(item)
    }
  }

  return result
})

function iconFor(id) {
  return getSectionIcon(id)
}
</script>
